










































































import Vue from "vue";
import Component from "vue-class-component";
import { CrudService } from "../../core/services/crudService";
import { Settings } from "../../core/services/configService";
import { LocalStorage } from "../../core/localStorage";
import CzButton from "../cz/CzButton.vue";

const STORAGE_KEY = "selectedCenterId";

@Component({
  components: { CzButton },
})
export default class Center extends Vue {
  centers: any[] = [];
  activeCenter: any = null;
  pendingCenterId: any = null;
  showPopup: boolean = false;

  get multipleCenters() {
    return this.centers.length > 1;
  }

  async getCenters() {
    const url = `${Settings.HostName}/api/publiccenters/get-all-centers`;
    var response = await new CrudService().httpGet(url);
    if (response.centers.length > 0) {
      this.centers = response.centers;
    }

    if (this.activeCenter || this.centers.length === 0) {
      return;
    }

    if (!this.multipleCenters) {
      this.selectCenter(this.centers[0]);
      return;
    }

    const savedId = LocalStorage.get(STORAGE_KEY);
    const saved =
      savedId !== null
        ? this.centers.find((c) => String(c.id) === savedId)
        : undefined;
    if (saved !== undefined) {
      this.selectCenter(saved);
      return;
    }

    this.pendingCenterId = this.centers[0].id;
    this.showPopup = true;
  }

  centerAddress(center: any) {
    return center.address != null ? center.address : "";
  }

  openPopup() {
    this.pendingCenterId = this.activeCenter
      ? this.activeCenter.id
      : this.centers[0].id;
    this.showPopup = true;
  }

  confirmCenter() {
    const center = this.centers.find((c) => c.id === this.pendingCenterId);
    if (center === undefined) {
      return;
    }
    LocalStorage.add(STORAGE_KEY, String(center.id));
    this.showPopup = false;
    this.selectCenter(center);
  }

  selectCenter(center: any) {
    if (center === null || center === undefined) {
      return;
    }
    this.activeCenter = center;
    this.$emit("centerSelected", center, center.id === 0);
  }

  created() {
    this.config();
  }

  async config() {
    await this.getCenters();
  }
}
